import styled from "styled-components";

const Container = styled.div`
  width: 100%;

  // Header Bar Open and Close
  .headerBarOpen,
  .headerBarClose {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    padding: 20px 35px 20px 35px;
    background-color: white;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    transition: 0.15s ease;
    overflow: hidden;
  }

  // Header Bar Title
  .headerBarOpen h4,
  .headerBarClose h4 {
    font-size: 18px;
    color: var(--black);
    font-weight: 700;
    margin: 0px 20px 0px 0px;
    text-align: left;
  }

  // Header Bar Hover Image
  .headerBarClose:hover > img {
    -webkit-transition: 0.3s;
    -moz-transition: 0.3s;
    -ms-transition: 0.3s;
    -o-transition: 0.3s;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  // Text Container
  .displayText {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
    align-content: flex-start;
  }

  // Text hr
  .displayText hr {
    width: 100%;
    border-top: 1px solid var(--orange);
    margin: 0px 0px 0px 0px;
  }

  // Text hr Close
  .hrClose {
    width: 97% !important;
    transition: 0.9s all;
  }

  // Text
  .displayText p {
    width: 100%;
    font-size: 15px;
    text-align: left;
    margin: 0px 0px 0px 0px;
    padding: 25px 35px 25px 35px;
  }

  // Tiempo de transicion cuando se abre y se cierra
  .ReactCollapse--collapse {
    transition: height 300ms;
  }
`;

export default Container;
